//DATA for the app
export const EventType = {
  hourly: { Id: 100046286, Name: 'Online Booking' },
  weekly: { Id: 100046976, Name: 'Online Booking Weekly' },
  monthly: { Id: 100046977, Name: 'Online Booking Monthly' },
  yearly: { Id: 100046978, Name: 'Online Booking Yearly' },
  other: { Id: 100047140, Name: 'Facility Online Booking General' },
  afterhour: { Id: 100047139, Name: 'Online Booking after hour' },
};

export const OrganisationType = {
  Corporate: { Id: 100014520, Name: 'Corporate' },
  NonCommercial: { Id: 100014470, Name: 'NonCommercial' },
  Commercial: { Id: 100014469, Name: 'Commercial' },
  Community: { Id: 100010011, Name: 'Community' },
  General: { Id: 100014519, Name: 'General' },
  Special: { Id: 100014471, Name: 'Special' },
};

export const surchargeRate = 0.0075;

export const searchResultLimit = 5;

export const weeklyDefinition = 5;

export const DefaultOnlineBookingOwnerId = { Id: 100017806 }; // do not swap this one, this is a dummy created in the system

export const DefaultContactType = { Id: 9715, Name: 'Contact' };

export const DefaultEventSource = { Id: 6, Name: 'Website' };

export const DefaultBookingType = { Id: 8199, Name: 'Function' };

export const DefaultBookingStatus = { Id: 8862, Type: 'Reserved' };

export const DefaultInquirySource = { Id: 100006904, Name: 'Web Enquiry' };

export const DefaultOpportunitySource = { Id: 8466, Name: 'Website' };

export const DefaultVenuesList = {
  CatalogueTypeName: 'Venue',
  IncludeInactive: true,
  LastUpdatedDate: '18/08/2021 01:00:00',
};

export const DefaultEventStatus = {
  Type: 'Reserved',
  TextColour: '#000000',
  Color: '#005e00',
  Id: 8862,
  Name: 'Confirmed Casual',
  Colour: '#005e00',
};

export const DefaultEventCoordinator = {
  Type: 'Users',
  PriavaUserId: 100017806, // 100011647 this is the dummy id
  Id: 100017806,
  Name: 'Priava Online Booking Coodinator', ///TODO host information needs to be dynamic or great from the system
  APIUserType: '',
};

export const Tennis = {
  groupId: 0,
  whatisincluded: ['TBC'],
  vennueName: 'Tennis Court',
  venueIds: [
    //800002102, 800002103, 800002104, 800002105, 800002106, 800002107, 800002108,
    //800002109, 800002110, 800002111,

    100493406,
    100493408, 100493409, 100493410, 100493411, 100493413, 100493416, 100493417,
    100493419, 100493420,
  ],
  pricingCatalogue: {
    hourly: 100478634,
    weekly: 0,
  },
  account: 12213,
  rtype: 901,
  dailyOnly: false,
  key: 'tennis',
  allowRecursive: false,
  opsHour: {
    fieldOpeningHour: 8,
    fieldCloseHour: 22,
  },
};
